<template>
  <!--  <lazy-dom>-->
  <div class="policy-form">
    <el-form
      ref="form"
      :rules="rules"
      :model="formData">
      <div class="box">
        <h3>Quote Details</h3>
        <div class="form-item form-half">
          <span>Expected Effective Date</span>
          <el-form-item
            ref="pcy_cmnt_dt"
            :rules="rules.select"
            prop="pcy_cmnt_dt"
          >
            <v-date-picker
              v-model="formData.pcy_cmnt_dt"
            />
          </el-form-item>
        </div>
        <div class="form-item form-half">
          <span>Insurer</span>
          <el-form-item
            ref="company_id"
            :rules="rules.select"
            prop="company_id"
          >
            <v-select
              v-model="formData.company_id"
              :block="true"
              :list="newSMEOptions.insurer" />
          </el-form-item>
        </div>
        <div class="form-item">
          <span>Plan Name</span>
          <el-form-item
            ref="plan_name"
            :rules="rules.input"
            prop="plan_name"
          >
            <v-input
              v-model="formData.plan_name"
              key-non-chinese
            />
          </el-form-item>
        </div>
        <div class="flex flex-sb-center">
          <div class="form-item form-half">
            <span>Insurer Application Form</span>
            <el-form-item
              ref="prop_pdf_path"
              :rules="rules.upload"
              prop="prop_pdf_path">
              <file-container
                :fileData="formData.prop_pdf_path_file"
                :edit="true"
                is-show-detail
                :show-left-name="false"
                is-none-name
                :is-viewer="true"
                :otherData="{
                  target: 'prop_pdf_path_file',
                  idKey: 'prop_pdf_path',
                }"
                @delete="handlerDeleteFile"
                @uploadSuccess="handlerUploadSuccess"
              >
              </file-container>
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Insurer Official Quotation</span>
            <el-form-item
              ref="insurer_quotation_path"
              :rules="rules.upload"
              prop="insurer_quotation_path">
              <file-container
                :fileData="formData.insurer_quotation_path_file"
                :edit="true"
                is-show-detail
                :show-left-name="false"
                :is-viewer="true"
                is-none-name
                :otherData="{
                  target: 'insurer_quotation_path_file',
                  idKey: 'insurer_quotation_path'
                }"
                @delete="handlerDeleteFile"
                @uploadSuccess="handlerUploadSuccess"
              >
              </file-container>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="box">
        <h3>Coverage</h3>
        <div class="form-item">
          <span>Content</span>
          <el-form-item
            ref="cal_type_contents"
            :rules="rules.select"
            prop="cal_type_contents">
            <v-radio-group
              v-model="formData.cal_type_contents"
              :list="newSMEOptions.cal_type"
              @change="handleComputed"/>
          </el-form-item>
          <div class="flex-align-center mg-t-8">
            <template v-if="formData.cal_type_contents==1">
              <el-form-item
                ref="contents_isrd"
                :rules="rules.input"
                prop="contents_isrd">
                <v-input
                  v-model="formData.contents_isrd"
                  key-non-chinese
                  class="width-128"
                  :key-float-number="true"
                  prepend="$"
                  @change="handleComputed"
                ></v-input>
              </el-form-item>

              <span class="mg-l-8 mg-r-8">
                <font-awesome-icon icon="xmark"></font-awesome-icon>
              </span>
              <el-form-item
                ref="contents_pct"
                :rules="rules.input"
                prop="contents_pct">
                <v-input
                  v-model="formData.contents_pct"
                  class="width-68"
                  key-non-chinese
                  :key-float-number="true"
                  append="%"
                  @change="handleComputed"
                ></v-input>
              </el-form-item>
              <span class="mg-l-8 mg-r-8">
                <font-awesome-icon icon="equals"></font-awesome-icon>
              </span>
            </template>
            <el-form-item
              ref="contents_prm"
              :rules="rules.input"
              prop="contents_prm">
              <v-input
                v-model="formData.contents_prm"
                key-non-chinese
                :disabled="formData.cal_type_contents==1"
                class="width-128"
                :key-float-number="true"
                prepend="$"
                @blur="handleComputed"
              ></v-input>
            </el-form-item>
            <template v-if="formData.cal_type_contents==1">
              <span class="mg-l-8 mg-r-8">
                <font-awesome-icon icon="slash"></font-awesome-icon>
              </span>
              <span class="mg-r-8 fs-14 fw-600">mini </span>
              <el-form-item
                ref="min_sub_contents_prm"
                :rules="rules.input"
                prop="min_sub_contents_prm">
                <v-input
                  v-model="formData.min_sub_contents_prm"
                  key-non-chinese
                  class="width-128"
                  :key-float-number="true"
                  prepend="$"
                  @change="handleComputed"
                ></v-input>
              </el-form-item>
            </template>
          </div>
        </div>
        <div class="form-item">
          <span>Content (Stock)</span>
          <el-form-item
            ref="cal_type_stocks"
            :rules="rules.smeSelect"
            prop="cal_type_stocks"
            @change="handleComputed">
            <v-radio-group
              v-model="formData.cal_type_stocks"
              :list="newSMEOptions.cal_type" />
          </el-form-item>
          <div class="flex-align-center mg-t-8">
            <template v-if="formData.cal_type_stocks==1">
              <el-form-item
                ref="stocks_isrd"
                :rules="rules.input"
                prop="stocks_isrd">
                <v-input
                  v-model="formData.stocks_isrd"
                  key-non-chinese
                  :key-float-number="true"
                  prepend="$"
                  class="width-128"
                  @change="handleComputed"
                ></v-input>
              </el-form-item>

              <span class="mg-l-8 mg-r-8">
                <font-awesome-icon icon="xmark"></font-awesome-icon>
              </span>
              <el-form-item
                ref="stocks_pct"
                :rules="rules.input"
                prop="stocks_pct">
                <v-input
                  v-model="formData.stocks_pct"
                  class="width-68"
                  key-non-chinese
                  :key-float-number="true"
                  append="%"
                  @change="handleComputed"
                ></v-input>
              </el-form-item>
              <span class="mg-l-8 mg-r-8">
                <font-awesome-icon icon="equals"></font-awesome-icon>
              </span>
            </template>
            <el-form-item
              ref="stocks_prm"
              :rules="rules.input"
              prop="stocks_prm">
              <v-input
                v-model="formData.stocks_prm"
                key-non-chinese
                :disabled="formData.cal_type_stocks==1"
                :key-float-number="true"
                prepend="$"
                class="width-128"
                @blur="handleComputed"
              ></v-input>
            </el-form-item>
            <template v-if="formData.cal_type_stocks==1">
              <span class="mg-l-8 mg-r-8">
                <font-awesome-icon icon="slash"></font-awesome-icon>
              </span>
              <span class="mg-r-8 fs-14 fw-600">mini </span>
              <el-form-item
                ref="min_sub_stocks_prm"
                :rules="rules.input"
                prop="min_sub_stocks_prm">
                <v-input
                  v-model="formData.min_sub_stocks_prm"
                  key-non-chinese
                  :key-float-number="true"
                  class="width-128"
                  prepend="$"
                  @change="handleComputed"
                ></v-input>
              </el-form-item>
            </template>
          </div>
        </div>
        <div class="form-item">
          <span>Content (Machinery)</span>
          <el-form-item
            ref="cal_type_dev"
            :rules="rules.select"
            prop="cal_type_dev">
            <v-radio-group
              v-model="formData.cal_type_dev"
              :list="newSMEOptions.cal_type"
              @change="handleComputed" />
          </el-form-item>
          <div class="flex-align-center mg-t-8">
            <template v-if="formData.cal_type_dev==1">
              <el-form-item
                ref="high_value_dev_isrd"
                :rules="rules.input"
                prop="high_value_dev_isrd">
                <v-input
                  v-model="formData.high_value_dev_isrd"
                  class="width-128"
                  key-non-chinese
                  :key-float-number="true"
                  prepend="$"
                  @change="handleComputed"
                ></v-input>
              </el-form-item>
              <span class="mg-l-8 mg-r-8">
                <font-awesome-icon icon="xmark"></font-awesome-icon>
              </span>
              <el-form-item
                ref="high_value_dev_pct"
                :rules="rules.input"
                prop="high_value_dev_pct">
                <v-input
                  v-model="formData.high_value_dev_pct"
                  class="width-68"
                  key-non-chinese
                  :key-float-number="true"
                  append="%"
                  @change="handleComputed"
                ></v-input>
              </el-form-item>
              <span class="mg-l-8 mg-r-8">
                <font-awesome-icon icon="equals"></font-awesome-icon>
              </span>
            </template>
            <el-form-item
              ref="high_value_dev_prm"
              :rules="rules.input"
              prop="high_value_dev_prm">
              <v-input
                v-model="formData.high_value_dev_prm"
                class="width-128"
                :disabled="formData.cal_type_dev==1"
                key-non-chinese
                :key-float-number="true"
                prepend="$"
                @blur="handleComputed"
              ></v-input>
            </el-form-item>
            <template v-if="formData.cal_type_dev==1">
              <span class="mg-l-8 mg-r-8">
                <font-awesome-icon icon="slash"></font-awesome-icon>
              </span>
              <span class="mg-r-8 fs-14 fw-600">mini </span>
              <el-form-item
                ref="min_sub_dev_prm"
                :rules="rules.input"
                prop="min_sub_dev_prm">
                <v-input
                  v-model="formData.min_sub_dev_prm"
                  class="width-128"
                  key-non-chinese
                  :key-float-number="true"
                  prepend="$"
                  @change="handleComputed"
                ></v-input>
              </el-form-item>
            </template>
          </div>
        </div>
        <div class="form-item">
          <span>Public Liability</span>
          <el-form-item
            ref="total_pl_prm"
            :rules="rules.input"
            prop="total_pl_prm">
            <v-input
              v-model="formData.total_pl_prm"
              key-non-chinese
              class="width-128"
              :key-float-number="true"
              prepend="$"
              @blur="handleComputed"
            ></v-input>
          </el-form-item>
        </div>
      </div>
      <div class="box">
        <h3>Employee's Compensation</h3>
        <div
          v-for="(item,index) in formData.ec_prm_detail"
          :key="'ec_'+index"
          class="form-item">
          <span>{{item.title}}</span>
          <div class="flex-align-center">
            <el-form-item
            >
              <v-input
                v-model="item.annual_salary"
                class="width-128"
                key-non-chinese
                :key-float-number="true"
                prepend="$"
                @change="handleComputed"
              ></v-input>
            </el-form-item>
            <span class="mg-l-8 mg-r-8">
              <font-awesome-icon icon="xmark"></font-awesome-icon>
            </span>
            <el-form-item
              :ref="`ec_prm_detail.${index}.prm_pct`"
              :rules="rules.input"
              :prop="`ec_prm_detail.${index}.prm_pct`">
              <v-input
                v-model="item.prm_pct"
                class="width-68"
                key-non-chinese
                :key-float-number="true"
                append="%"
                @change="handleComputed"
              ></v-input>
            </el-form-item>
            <span class="mg-l-8 mg-r-8">
              <font-awesome-icon icon="equals"></font-awesome-icon>
            </span>
            <el-form-item>
              <v-input
                v-model="item.annual_prm"
                class="width-128"
                key-non-chinese
                disabled
                :key-float-number="true"
                prepend="$"
              ></v-input>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="box">
        <h3>Excess</h3>
        <div
          v-for="(excess_item,index) in formData.excess"
          :key="'excess_'+index"
          class="flex-align-center">
          <div class="form-item form-half">
            <span>Item</span>
            <el-form-item
              :ref="`excess.${index}.item`"
              :rules="rules.input"
              :prop="`excess.${index}.item`">
              <v-input
                v-model="excess_item.item"
                key-non-chinese
                :rows="4"
                type="textarea"
              ></v-input>
            </el-form-item>
          </div>
          <div class="form-item form-half mg-l-20">
            <span>Content</span>
            <el-form-item
              :ref="`excess.${index}.content`"
              :rules="rules.smeSelect"
              :prop="`excess.${index}.content`">
              <v-input
                v-model="excess_item.content"
                key-non-chinese
                :rows="4"
                type="textarea"
              ></v-input>
            </el-form-item>
          </div>
          <span class="mg-l-14">
            <font-awesome-icon
              class="color-del"
              icon="trash-alt"
              @click="handleDelExcess(index)"></font-awesome-icon>
          </span>
        </div>
        <div>
          <v-button
            blue
            icon="plus"
            @click="handleAddExcess">Add</v-button>
        </div>
      </div>
      <div class="box mg-t-15">
        <h3>Premium</h3>
        <sme-premium
          ref="sme-premium"
          :customer-id="form.customer_id"
          :order-id="form.order_id"
          :form="formData"
          :detailData="form"
          :premium="formData.premium"
          @cal="handleComputed"></sme-premium>
      </div>
    </el-form>
  </div>
<!--  </lazy-dom>-->
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import SmePremium from './sme-preimum'
import {replySMEQuoteDetail,replySMEQuoteCal} from '@api/new_sme'
import {mapState} from 'vuex'
export default {
  name: 'reply-form',
  components: {SmePremium},
  mixins: [MixinOptions, MixinFormat, MixinRules],
  props:{
    form:{
      type:Object,
      default:()=>({})
    }
  },
  data() {
    return{
      detailData:{},
      formData:{
        plan_name:'',
        pcy_cmnt_dt:'',
        company_id:'',
        prop_pdf_path:'',
        prop_pdf_path_file:{},
        insurer_quotation_path:'',
        insurer_quotation_path_file:{},
        cal_type_contents:'',
        contents_isrd:'',
        contents_pct:'',
        contents_prm:'',
        min_sub_contents_prm:'',
        cal_type_stocks:'',
        stocks_isrd:'',
        stocks_pct:'',
        stocks_prm:'',
        min_sub_stocks_prm:'',
        cal_type_dev:'',
        high_value_dev_isrd:'',
        high_value_dev_pct:'',
        high_value_dev_prm:'',
        min_sub_dev_prm:'',
        total_pl_prm:'',
        ec_prm_detail:[],
        excess:[],
        spec_disc_prm:0,
        code_disc_prm:0,
        handling_fee:0,
        code:'',
        referrer_user_id:'',
        coupon_code:'',
        premium:[]
      },
    }
  },
  computed:{
    ...mapState('coupon', ['couponCode','selectCode']),
  },
  mounted() {
    this.network().replySMEQuoteDetail()
  },
  methods:{
    handlerUploadSuccess({ data, result, otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData
      const { id, path,thumb_url,url } = data
      this.$set(this.formData,target,data)
      this.$set(this.formData,idKey,id)
    },
    handlerDeleteFile(otherData) {
      let { type, index,target } = otherData
      this.$set(this.formData,target,{})
      this.$set(this.formData,idKey,'')
    },
    handleComputed(data){
      this.formData = {...this.formData,...data}
      this.network().replySMEQuoteCal()
    },
    handleAddExcess(){
      this.formData.excess.push({item:'',content:''})
    },
    handleDelExcess(index){
      this.formData.excess.splice(index,1)
    },
    submitForm(){
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate((valid, rules) => {
          if(valid){
            resolve({...this.formData})
          }else
            reject()
        })
      })
    },
    network(){
      return{
        replySMEQuoteDetail:async (params)=>{
          let {order_id} = this.form||{}
          let {data} = await replySMEQuoteDetail({...params,order_id})
          Object.keys(this.formData).some(key => {
            if(key in data) {
              this.formData[key] =data[key]
            }
          })
          let {excess,prop_pdf_path,insurer_quotation_path} = data||{}
          if(!excess){
            this.formData.excess =[]
          }
          if(data.prop_pdf_path)
          {
            let {id} = data.prop_pdf_path
            this.formData.prop_pdf_path_file = prop_pdf_path
            this.formData.prop_pdf_path = id
          }
          if(data.insurer_quotation_path)
          {
            let {id} = data.insurer_quotation_path
            this.formData.insurer_quotation_path_file = insurer_quotation_path
            this.formData.insurer_quotation_path = id
          }
          this.$refs['sme-premium'].handlerSetCode()
        },
        replySMEQuoteCal:async (params={})=>{
          let {order_id} = this.form||{}
          // let {selectCode, coupon = {}, code = {}} = this.selectCode || {}
          // if (coupon.selectCode == 1) {
          //   params.coupon_code = coupon.coupon_code
          // }
          // if (code.selectCode == 2) {
          //   params.code = code.code
          // }
          // console.log('this.selectCode==',this.selectCode)
          let {data} = await replySMEQuoteCal({...this.formData,...params,order_id})
          Object.keys(this.formData).some(key => {
            if(key in data) {
              this.formData[key] =data[key]
            }
          })
          let {referrer} = data||{}
          this.$emit('updateRefer',referrer)
        },
      }
    }
  }

}
</script>

<style lang="scss" scoped>
/deep/.policy-form{
  width: 690px!important;
}
.policy-form{
  width: 690px!important;
  max-width: 690px;
  .box {
    padding-bottom: 15px;
    h3{
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #24292E;
    }
  }
  .travel-box{
    .flex{
      flex-wrap: wrap;
    }
  }
  .margin-top{
    margin-top: 10px;
  }
  .gray{
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
    display: inline-block;
  }
}
/deep/ .max-content{
  width: max-content;
}
.select-time{
  .el-date-editor{
    width: 100%;
  }
}
.form-item{
  >span{
    &:first-child {
      display: block;
      padding-bottom: 8px;
    }
  }
  .sme--content__tip{
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #586069;
    padding-bottom: 0;
  }
  /deep/.v-radio-group{
    .el-radio-group{
      .el-radio{
        margin-right: 20px!important;
      }
    }
  }
  .width-68{
    width: 78px;
    /deep/.el-input__inner{
      padding: 0 10px!important;
    }
  }
  .width-128{
    width: 128px;
    /deep/.el-input__inner{
      padding: 0 10px!important;
    }
  }
  /deep/.el-form-item{
    .el-input-group--append{
      //.el-input__inner{
      //  border-right: 0;
      //}
    }
    .el-input-group__append{
      padding: 0 5px;
      border-left: 0;
      //background: #fff;
    }
    .el-input-group__prepend{
      border-right: 0;
      //background: #fff;
    }
  }

}
</style>
